import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../features/auth/authSlice';
import {
  getUsers, createUser, deactivateUser,
  getAdminReportGroups, createReportGroup,
  getAdminReports, createReport,
  addReportToGroup, removeReportFromGroup,
  addUserToGroup, removeUserFromGroup,
  getPowerBiReports, toggleCanAccessTest,
  getReportContexts, createReportContext, updateReportContext, deleteReportContext, assignContextToReport,
  getTenants, createTenant, updateTenant, toggleTenant, deleteTenant
} from '../services/adminService';
import {
  getTeams, createTeam, updateTeam, deleteTeam,
  getRegions, createRegion, deleteRegion,
  getReps, createRep, deleteRep,
  getRepBricks, createRepBrick, closeRepBrick, deleteRepBrick,
  getMarkets, createMarket, updateMarket, deleteMarket,
  getProducts, bulkUpdateProducts,
  assignProductToMarket, removeProductFromMarket,
  getGeography, bulkImportSalesForce,
  bulkImportProductsMarkets          // ← YENİ
} from '../services/adminService';
import apiClient from '../services/apiClient';
import BrickAssignmentPanel from './BrickAssignmentPanel';
const ITEMS_PER_PAGE = 10;

const AdminPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, isSuperAdmin } = useSelector((state) => state.auth);

  const [activeTab, setActiveTab] = useState('users');
  const [users, setUsers] = useState([]);
  const [reportGroups, setReportGroups] = useState([]);
  const [reports, setReports] = useState([]);
  const [reportContexts, setReportContexts] = useState([]);
  const [feedbacks, setFeedbacks] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  // Power BI raporlar — tenant+environment kombinasyonuna göre
  const [powerBiReports, setPowerBiReports] = useState([]);
  const [powerBiLoading, setPowerBiLoading] = useState(false);

  // Arama
  const [userSearch, setUserSearch] = useState('');
  const [groupSearch, setGroupSearch] = useState('');
  const [reportSearch, setReportSearch] = useState('');
  const [contextSearch, setContextSearch] = useState('');
  const [feedbackSearch, setFeedbackSearch] = useState('');
  const [tenantSearch, setTenantSearch] = useState('');

  // Sayfalama
  const [userPage, setUserPage] = useState(1);
  const [groupPage, setGroupPage] = useState(1);
  const [reportPage, setReportPage] = useState(1);
  const [contextPage, setContextPage] = useState(1);
  const [feedbackPage, setFeedbackPage] = useState(1);
  const [tenantPage, setTenantPage] = useState(1);

  // Kullanıcı formu
  const [newUserEmail, setNewUserEmail] = useState('');
  const [newUserFullName, setNewUserFullName] = useState('');
  const [newUserTenantId, setNewUserTenantId] = useState('');

  // Rapor grubu formu
  const [newGroupName, setNewGroupName] = useState('');
  const [newGroupDesc, setNewGroupDesc] = useState('');
  const [newGroupEnv, setNewGroupEnv] = useState('prod');
  const [newGroupTenantId, setNewGroupTenantId] = useState('');
  const [newGroupAiChat, setNewGroupAiChat] = useState(true);

  // Rapor formu
  const [newReportName, setNewReportName] = useState('');
  const [newReportId, setNewReportId] = useState('');
  const [newReportDesc, setNewReportDesc] = useState('');
  const [newReportEnv, setNewReportEnv] = useState('prod');
  const [newReportTenantId, setNewReportTenantId] = useState('');

  // Context formu
  const [newContextName, setNewContextName] = useState('');
  const [newContextDimensions, setNewContextDimensions] = useState('');
  const [newContextMeasures, setNewContextMeasures] = useState('');
  const [newContextRules, setNewContextRules] = useState('');
  const [editingContext, setEditingContext] = useState(null);

  // Tenant formu
  const [newTenantName, setNewTenantName] = useState('');
  const [newTenantDesc, setNewTenantDesc] = useState('');
  const [newTenantWorkspaceId, setNewTenantWorkspaceId] = useState('');
  const [newTenantTestWorkspaceId, setNewTenantTestWorkspaceId] = useState('');
  const [editingTenant, setEditingTenant] = useState(null);
  const [newTenantPrimaryColor, setNewTenantPrimaryColor] = useState('#1a1a2e');
  const [newTenantSecondaryColor, setNewTenantSecondaryColor] = useState('#2e75b6');
  const [newTenantLogoUrl, setNewTenantLogoUrl] = useState('');
  const [newTenantFaviconUrl, setNewTenantFaviconUrl] = useState('');
  const [newTenantPortalTitle, setNewTenantPortalTitle] = useState('');

  // Master Data
  const [mdSubTab, setMdSubTab] = useState('salesforce');
  const [mdTenantId, setMdTenantId] = useState('');
  const [teams, setTeams] = useState([]);
  const [regions, setRegions] = useState([]);
  const [reps, setReps] = useState([]);
  const [repBricks, setRepBricks] = useState([]);
  const [markets, setMarkets] = useState([]);
  const [products, setProducts] = useState([]);
  const [geography, setGeography] = useState([]);
  const [mdLoading, setMdLoading] = useState(false);

  // Saha ekibi bulk import
  const [bulkFile, setBulkFile] = useState(null);
  const [bulkImporting, setBulkImporting] = useState(false);
  const [bulkErrors, setBulkErrors] = useState([]);
  const [bulkResult, setBulkResult] = useState(null);

  // ── YENİ: Ürün & Pazar bulk import ──────────────────────────────────────
  const [pmFile, setPmFile] = useState(null);
  const [pmLoading, setPmLoading] = useState(false);
  const [pmResult, setPmResult] = useState(null);
  const [pmErrors, setPmErrors] = useState([]);
  // ────────────────────────────────────────────────────────────────────────

  // Tekil formlar
  const [newTeamName, setNewTeamName] = useState('');
  const [newRegionName, setNewRegionName] = useState('');
  const [newRegionTeamId, setNewRegionTeamId] = useState('');
  const [newRepName, setNewRepName] = useState('');
  const [newRepCode, setNewRepCode] = useState('');
  const [newRepRegionId, setNewRepRegionId] = useState('');
  const [newMarketName, setNewMarketName] = useState('');
  const [newMarketTeamId, setNewMarketTeamId] = useState('');

  const loadMasterData = async (tid) => {
    const tenantId = tid || (isSuperAdmin ? null : null);
    if (isSuperAdmin && !tenantId) return;
    setMdLoading(true);
    try {
      const [t, r, rp, rb, m, p, g] = await Promise.all([
          getTeams(tenantId),
          getRegions(tenantId),
          getReps(tenantId),
          getRepBricks(tenantId),
          getMarkets(tenantId),
          getProducts(tenantId),
          getGeography(tenantId)
      ]);
      setTeams(t);
      setRegions(r);
      setReps(rp);
      setRepBricks(rb);
      setMarkets(m);
      setProducts(p);
      setGeography(g);
    } catch {
      setMessage('Master data yüklenirken hata oluştu.');
    } finally {
      setMdLoading(false);
    }
  };

  const loadPowerBiReports = useCallback(async (environment, tenantId) => {
    if (isSuperAdmin && !tenantId) {
      setPowerBiReports([]);
      return;
    }
    setPowerBiLoading(true);
    try {
      const result = await getPowerBiReports(environment, tenantId || null);
      setPowerBiReports(result);
    } catch {
      setPowerBiReports([]);
    } finally {
      setPowerBiLoading(false);
    }
  }, [isSuperAdmin]);

  useEffect(() => { loadAll(); }, [isSuperAdmin]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (activeTab === 'masterdata') {
      const tid = isSuperAdmin ? (mdTenantId || null) : user?.tenantId;
      loadMasterData(tid);
    }
  }, [activeTab, mdTenantId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (activeTab === 'feedbacks' && feedbacks.length === 0) loadFeedbacks();
    if (activeTab === 'tenants' && tenants.length === 0) loadTenants();
  }, [activeTab]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (activeTab === 'reports') {
      const tenantId = isSuperAdmin ? (newReportTenantId || null) : null;
      loadPowerBiReports(newReportEnv, tenantId);
      setNewReportId('');
      setNewReportName('');
    }
  }, [newReportEnv, newReportTenantId, activeTab]); // eslint-disable-line react-hooks/exhaustive-deps

  const loadAll = async () => {
    setLoading(true);
    try {
      const promises = [
        getUsers(), getAdminReportGroups(), getAdminReports(), getReportContexts()
      ];
      if (isSuperAdmin) promises.push(getTenants());

      const results = await Promise.all(promises);
      setUsers(results[0]);
      setReportGroups(results[1]);
      setReports(results[2]);
      setReportContexts(results[3]);
      if (isSuperAdmin) setTenants(results[4]);
    } catch {
      setMessage('Veriler yüklenirken hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const loadFeedbacks = async () => {
    try {
      const response = await apiClient.get('/feedback');
      setFeedbacks(response.data);
    } catch {
      setMessage('Feedback verileri yüklenemedi.');
    }
  };

  const loadTenants = async () => {
    try {
      const data = await getTenants();
      setTenants(data);
    } catch {
      setMessage('Tenant verileri yüklenemedi.');
    }
  };

  // Filtreler
  const filteredUsers = users.filter(u =>
    u.fullName?.toLowerCase().includes(userSearch.toLowerCase()) ||
    u.email?.toLowerCase().includes(userSearch.toLowerCase())
  );
  const filteredGroups = reportGroups.filter(g => g.name?.toLowerCase().includes(groupSearch.toLowerCase()));
  const filteredReports = reports.filter(r => r.name?.toLowerCase().includes(reportSearch.toLowerCase()));
  const filteredContexts = reportContexts.filter(c => c.name?.toLowerCase().includes(contextSearch.toLowerCase()));
  const filteredFeedbacks = feedbacks.filter(f =>
    f.userMessage?.toLowerCase().includes(feedbackSearch.toLowerCase()) ||
    f.userEmail?.toLowerCase().includes(feedbackSearch.toLowerCase()) ||
    f.userComment?.toLowerCase().includes(feedbackSearch.toLowerCase())
  );
  const filteredTenants = tenants.filter(t =>
    t.name?.toLowerCase().includes(tenantSearch.toLowerCase())
  );

  const paginate = (items, page) => items.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE);
  const totalPages = (items) => Math.ceil(items.length / ITEMS_PER_PAGE);

  // Handler'lar
  const handleCreateUser = async (e) => {
    e.preventDefault();
    try {
      await createUser(newUserEmail, newUserFullName, [], isSuperAdmin ? parseInt(newUserTenantId) || null : null);
      setMessage('Kullanıcı oluşturuldu. Aktivasyon maili gönderildi.');
      setNewUserEmail(''); setNewUserFullName(''); setNewUserTenantId('');
      loadAll();
    } catch { setMessage('Kullanıcı oluşturulamadı.'); }
  };

  const handleDeactivateUser = async (userId) => {
    if (!window.confirm('Kullanıcıyı deaktif etmek istiyor musunuz?')) return;
    try {
      await deactivateUser(userId);
      setMessage('Kullanıcı deaktif edildi.');
      loadAll();
    } catch { setMessage('İşlem başarısız.'); }
  };

  const handleToggleCanAccessTest = async (userId) => {
    try {
      await toggleCanAccessTest(userId);
      setMessage('Test erişimi güncellendi.');
      loadAll();
    } catch { setMessage('İşlem başarısız.'); }
  };

  const handleCreateGroup = async (e) => {
    e.preventDefault();
    try {
      await createReportGroup(
        newGroupName, newGroupDesc,
        isSuperAdmin ? parseInt(newGroupTenantId) || null : null,
        newGroupEnv
      );
      setMessage(`Rapor grubu oluşturuldu (${newGroupEnv === 'test' ? 'Test' : 'Production'}).`);
      setNewGroupName(''); setNewGroupDesc(''); setNewGroupTenantId(''); setNewGroupEnv('prod');
      loadAll();
    } catch { setMessage('Rapor grubu oluşturulamadı.'); }
  };

  const handleCreateReport = async (e) => {
    e.preventDefault();
    try {
      const selectedPbReport = powerBiReports.find(r => r.id === newReportId);
      await createReport(
        newReportName, newReportId, newReportDesc, newReportEnv,
        selectedPbReport?.workspaceId || '',
        isSuperAdmin ? parseInt(newReportTenantId) || null : null
      );
      setMessage(`Rapor oluşturuldu (${newReportEnv === 'test' ? 'Test' : 'Production'}).`);
      setNewReportName(''); setNewReportId(''); setNewReportDesc('');
      loadAll();
    } catch { setMessage('Rapor oluşturulamadı.'); }
  };

  const handleAddReportToGroup = async (groupId, reportId) => {
    try {
      await addReportToGroup(groupId, reportId);
      setMessage('Rapor gruba eklendi.');
      loadAll();
    } catch (err) {
      setMessage(err.response?.data?.message || 'İşlem başarısız.');
    }
  };

  const handleRemoveReportFromGroup = async (groupId, reportId) => {
    try { await removeReportFromGroup(groupId, reportId); setMessage('Rapor gruptan çıkarıldı.'); loadAll(); }
    catch { setMessage('İşlem başarısız.'); }
  };

  const handleAddUserToGroup = async (userId, groupId) => {
    try { await addUserToGroup(userId, groupId); setMessage('Kullanıcı gruba eklendi.'); loadAll(); }
    catch { setMessage('İşlem başarısız.'); }
  };

  const handleRemoveUserFromGroup = async (userId, groupId) => {
    try { await removeUserFromGroup(userId, groupId); setMessage('Kullanıcı gruptan çıkarıldı.'); loadAll(); }
    catch { setMessage('İşlem başarısız.'); }
  };

  const handleCreateContext = async (e) => {
    e.preventDefault();
    try {
      if (editingContext) {
        await updateReportContext(editingContext.id, newContextName, newContextDimensions, newContextMeasures, newContextRules);
        setMessage('Context güncellendi.');
        setEditingContext(null);
      } else {
        await createReportContext(newContextName, newContextDimensions, newContextMeasures, newContextRules);
        setMessage('Context oluşturuldu.');
      }
      setNewContextName(''); setNewContextDimensions(''); setNewContextMeasures(''); setNewContextRules('');
      loadAll();
    } catch { setMessage('İşlem başarısız.'); }
  };

  const handleEditContext = (context) => {
    setEditingContext(context);
    setNewContextName(context.name);
    setNewContextDimensions(context.dimensionDefinitions);
    setNewContextMeasures(context.measureDefinitions);
    setNewContextRules(context.systemPromptRules || '');
    window.scrollTo(0, 0);
  };

  const handleDeleteContext = async (id) => {
    if (!window.confirm('Context silinsin mi?')) return;
    try { await deleteReportContext(id); setMessage('Context silindi.'); loadAll(); }
    catch { setMessage('İşlem başarısız.'); }
  };

  const handleAssignContext = async (reportId, contextId) => {
    try { await assignContextToReport(reportId, parseInt(contextId) || 0); setMessage('Context rapora atandı.'); loadAll(); }
    catch { setMessage('İşlem başarısız.'); }
  };

  const handleCreateTenant = async (e) => {
    e.preventDefault();
    try {
      if (editingTenant) {
        await updateTenant(editingTenant.id, newTenantName, newTenantDesc, newTenantWorkspaceId, newTenantTestWorkspaceId || null, newTenantPrimaryColor, newTenantSecondaryColor, newTenantLogoUrl || null, newTenantFaviconUrl || null, newTenantPortalTitle || null);
        setMessage('Tenant güncellendi.');
        setEditingTenant(null);
      } else {
        await createTenant(newTenantName, newTenantDesc, newTenantWorkspaceId, newTenantTestWorkspaceId || null, newTenantPrimaryColor, newTenantSecondaryColor, newTenantLogoUrl || null, newTenantFaviconUrl || null, newTenantPortalTitle || null);
        setMessage('Tenant oluşturuldu.');
      }
      setNewTenantName(''); setNewTenantDesc('');
      setNewTenantWorkspaceId(''); setNewTenantTestWorkspaceId('');
      setNewTenantPrimaryColor('#1a1a2e'); setNewTenantSecondaryColor('#2e75b6');
      setNewTenantLogoUrl(''); setNewTenantFaviconUrl(''); setNewTenantPortalTitle('');
      loadTenants();
    } catch { setMessage('İşlem başarısız.'); }
  };

  const handleEditTenant = (tenant) => {
    setEditingTenant(tenant);
    setNewTenantName(tenant.name);
    setNewTenantDesc(tenant.description || '');
    setNewTenantWorkspaceId(tenant.powerBiWorkspaceId);
    setNewTenantTestWorkspaceId(tenant.powerBiTestWorkspaceId || '');
    setNewTenantPrimaryColor(tenant.primaryColor || '#1a1a2e');
    setNewTenantSecondaryColor(tenant.secondaryColor || '#2e75b6');
    setNewTenantLogoUrl(tenant.logoUrl || '');
    setNewTenantFaviconUrl(tenant.faviconUrl || '');
    setNewTenantPortalTitle(tenant.portalTitle || '');
    window.scrollTo(0, 0);
  };

  const handleToggleTenant = async (id) => {
    try { await toggleTenant(id); setMessage('Tenant durumu güncellendi.'); loadTenants(); }
    catch { setMessage('İşlem başarısız.'); }
  };

  const handleDeleteTenant = async (id) => {
    if (!window.confirm('Tenant silinsin mi? Bu işlem geri alınamaz.')) return;
    try { await deleteTenant(id); setMessage('Tenant silindi.'); loadTenants(); }
    catch (err) { setMessage(err.response?.data?.message || 'İşlem başarısız.'); }
  };

  // ── YENİ: Ürün & Pazar bulk import handler ───────────────────────────────
    const handleBulkImportProductsMarkets = async () => {
      if (!pmFile) {
        setMessage('Lütfen bir dosya seçin.');
        return;
      }
      setPmLoading(true);
      setPmResult(null);
      setPmErrors([]);
      try {
        const tid = isSuperAdmin ? mdTenantId : null;
        const res = await bulkImportProductsMarkets(pmFile, tid || null);
        setPmResult(res);
        setMessage(`✅ İçe aktarma tamamlandı.`);
        loadMasterData(isSuperAdmin ? mdTenantId : null);
      } catch (err) {
        // adminService throw { response: { data } } pattern'i kullanıyor
        const errors = err?.response?.data?.errors;
        if (errors && errors.length > 0) {
          setPmErrors(errors);
          setMessage('❌ Validasyon hataları bulundu. Lütfen Excel\'i düzeltin.');
        } else {
          setMessage(err?.response?.data?.message || err?.message || 'Bir hata oluştu.');
        }
      } finally {
        setPmLoading(false);
      }
    };
  // ────────────────────────────────────────────────────────────────────────

  const Pagination = ({ currentPage, total, onPageChange }) => {
    if (total <= 1) return null;
    return (
      <div style={styles.pagination}>
        <button style={styles.pageButton} onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>‹</button>
        {Array.from({ length: total }, (_, i) => i + 1).map(p => (
          <button key={p} style={{ ...styles.pageButton, ...(p === currentPage ? styles.pageButtonActive : {}) }} onClick={() => onPageChange(p)}>{p}</button>
        ))}
        <button style={styles.pageButton} onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === total}>›</button>
      </div>
    );
  };

  const EnvBadge = ({ env }) => (
    <span style={{
      backgroundColor: env === 'test' ? '#fef3c7' : '#dcfce7',
      color: env === 'test' ? '#92400e' : '#166534',
      padding: '2px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '600'
    }}>
      {env === 'test' ? '🧪 Test' : '🚀 Prod'}
    </span>
  );

  const tabs = [
    { key: 'users', label: `Kullanıcılar (${users.length})` },
    { key: 'groups', label: `Rapor Grupları (${reportGroups.length})` },
    { key: 'reports', label: `Raporlar (${reports.length})` },
    { key: 'contexts', label: `AI Modeller (${reportContexts.length})` },
    { key: 'feedbacks', label: `AI Feedbacks (${feedbacks.length})` },
    { key: 'masterdata', label: '📊 Master Data' },
    ...(isSuperAdmin ? [{ key: 'tenants', label: `Tenants (${tenants.length})` }] : [])
  ];

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.headerLeft}>
          <h2 style={styles.title}>Avixa Admin Panel</h2>
          {isSuperAdmin && <span style={styles.superAdminBadge}>⚡ Super Admin</span>}
        </div>
        <div style={styles.headerRight}>
          <span style={styles.userName}>{user?.fullName}</span>
          <button onClick={() => navigate('/')} style={styles.navButton}>Portal</button>
          <button onClick={() => { dispatch(logout()); navigate('/login'); }} style={styles.logoutButton}>Çıkış</button>
        </div>
      </div>

      <div style={styles.tabs}>
        {tabs.map(tab => (
          <button key={tab.key} style={{ ...styles.tab, ...(activeTab === tab.key ? styles.tabActive : {}) }} onClick={() => setActiveTab(tab.key)}>
            {tab.label}
          </button>
        ))}
      </div>

      {message && (
        <div style={styles.message} onClick={() => setMessage('')}>
          {message} <span style={{ cursor: 'pointer' }}>✕</span>
        </div>
      )}

      <div style={styles.content}>
        {loading && <p>Yükleniyor...</p>}

        {/* KULLANICILAR */}
        {activeTab === 'users' && !loading && (
          <div>
            <div style={styles.card}>
              <h3 style={styles.cardTitle}>Yeni Kullanıcı Ekle</h3>
              <form onSubmit={handleCreateUser} style={styles.form}>
                <input placeholder="Email" value={newUserEmail} onChange={e => setNewUserEmail(e.target.value)} style={styles.input} required type="email" />
                <input placeholder="Ad Soyad" value={newUserFullName} onChange={e => setNewUserFullName(e.target.value)} style={styles.input} required />
                {isSuperAdmin && (
                  <select style={styles.input} value={newUserTenantId} onChange={e => setNewUserTenantId(e.target.value)} required>
                    <option value="">Tenant Seçin...</option>
                    {tenants.filter(t => t.isActive).map(t => (
                      <option key={t.id} value={t.id}>{t.name}</option>
                    ))}
                  </select>
                )}
                <button type="submit" style={styles.primaryButton}>Oluştur</button>
              </form>
            </div>
            <div style={styles.card}>
              <div style={styles.tableHeader}>
                <h3 style={styles.cardTitle}>Kullanıcılar ({filteredUsers.length})</h3>
                <input placeholder="🔍 Ad veya email ara..." value={userSearch} onChange={e => { setUserSearch(e.target.value); setUserPage(1); }} style={styles.searchInput} />
              </div>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Ad Soyad</th>
                    <th style={styles.th}>Email</th>
                    <th style={styles.th}>Durum</th>
                    <th style={styles.th}>Admin</th>
                    {isSuperAdmin && <th style={styles.th}>Tenant</th>}
                    <th style={styles.th}>Rapor Grupları</th>
                    <th style={styles.th}>Test Erişimi</th>
                    <th style={styles.th}>İşlem</th>
                  </tr>
                </thead>
                <tbody>
                  {paginate(filteredUsers, userPage).map(u => (
                    <tr key={u.id}>
                      <td style={styles.td}>{u.fullName}</td>
                      <td style={styles.td}>{u.email}</td>
                      <td style={styles.td}><span style={{ color: u.isActive ? 'green' : 'red' }}>{u.isActive ? 'Aktif' : 'Pasif'}</span></td>
                      <td style={styles.td}>{u.isSuperAdmin ? '⚡' : u.isAdmin ? '✓' : '-'}</td>
                      {isSuperAdmin && <td style={styles.td}><span style={styles.tenantBadge}>{u.tenantName || '-'}</span></td>}
                      <td style={styles.td}>
                        <select style={styles.selectSmall} onChange={e => { if (e.target.value) handleAddUserToGroup(u.id, parseInt(e.target.value)); e.target.value = ''; }}>
                          <option value="">+ Grup Ekle</option>
                          {reportGroups
                            .filter(g => !u.reportGroups?.find(ug => ug.id === g.id))
                            .map(g => (
                              <option key={g.id} value={g.id}>
                                {g.name} ({g.environment === 'test' ? '🧪 Test' : '🚀 Prod'})
                              </option>
                            ))}
                        </select>
                        {u.reportGroups?.length > 0 && (
                          <div style={{ marginTop: '8px', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                            {u.reportGroups.map(g => (
                              <span key={g.id} style={styles.tag}>
                                {g.name}
                                <button onClick={() => handleRemoveUserFromGroup(u.id, g.id)} style={styles.tagRemove}>✕</button>
                              </span>
                            ))}
                          </div>
                        )}
                      </td>
                      <td style={styles.td}>
                        <button onClick={() => handleToggleCanAccessTest(u.id)} style={{ ...styles.primaryButton, backgroundColor: u.canAccessTest ? '#f59e0b' : '#6b7280', fontSize: '12px', padding: '4px 10px' }}>
                          {u.canAccessTest ? 'Aktif ✓' : 'Pasif'}
                        </button>
                      </td>
                      <td style={styles.td}>
                        {u.isActive && <button onClick={() => handleDeactivateUser(u.id)} style={styles.dangerButton}>Deaktif Et</button>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <Pagination currentPage={userPage} total={totalPages(filteredUsers)} onPageChange={setUserPage} />
            </div>
          </div>
        )}

        {/* RAPOR GRUPLARI */}
        {activeTab === 'groups' && !loading && (
          <div>
            <div style={styles.card}>
              <h3 style={styles.cardTitle}>Yeni Rapor Grubu</h3>
              <form onSubmit={handleCreateGroup} style={styles.form}>
                <input placeholder="Grup Adı" value={newGroupName} onChange={e => setNewGroupName(e.target.value)} style={styles.input} required />
                <input placeholder="Açıklama (opsiyonel)" value={newGroupDesc} onChange={e => setNewGroupDesc(e.target.value)} style={styles.input} />
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <label style={styles.label}>Ortam</label>
                  <select style={styles.input} value={newGroupEnv} onChange={e => setNewGroupEnv(e.target.value)}>
                    <option value="prod">🚀 Production</option>
                    <option value="test">🧪 Test</option>
                  </select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <label style={styles.label}>AI Chat</label>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }} onClick={() => setNewGroupAiChat(v => !v)}>
                    <div style={{ width: '40px', height: '22px', backgroundColor: newGroupAiChat ? '#1a1a2e' : '#d1d5db', borderRadius: '11px', position: 'relative', transition: 'background-color 0.2s' }}>
                      <div style={{ width: '18px', height: '18px', backgroundColor: 'white', borderRadius: '50%', position: 'absolute', top: '2px', left: newGroupAiChat ? '20px' : '2px', transition: 'left 0.2s' }} />
                    </div>
                    <span style={{ fontSize: '13px', color: '#374151' }}>{newGroupAiChat ? '🤖 Aktif' : 'Pasif'}</span>
                  </div>
                </div>
                {isSuperAdmin && (
                  <select style={styles.input} value={newGroupTenantId} onChange={e => setNewGroupTenantId(e.target.value)} required>
                    <option value="">Tenant Seçin...</option>
                    {tenants.filter(t => t.isActive).map(t => (
                      <option key={t.id} value={t.id}>{t.name}</option>
                    ))}
                  </select>
                )}
                <button type="submit" style={styles.primaryButton}>Oluştur</button>
              </form>
            </div>
            <div style={styles.card}>
              <div style={styles.tableHeader}>
                <h3 style={styles.cardTitle}>Rapor Grupları ({filteredGroups.length})</h3>
                <input placeholder="🔍 Grup ara..." value={groupSearch} onChange={e => { setGroupSearch(e.target.value); setGroupPage(1); }} style={styles.searchInput} />
              </div>
              {paginate(filteredGroups, groupPage).map(g => (
                <div key={g.id} style={styles.groupCard}>
                  <div style={styles.groupHeader}>
                    <strong>{g.name}</strong>
                    {g.description && <span style={styles.groupDesc}>{g.description}</span>}
                    <EnvBadge env={g.environment} />
                    <span style={styles.badge}>{g.reports?.length || 0} rapor</span>
                    {isSuperAdmin && g.tenantName && <span style={styles.tenantBadge}>{g.tenantName}</span>}
                  </div>
                  <div style={styles.groupBody}>
                    <p style={styles.label}>Raporlar:</p>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '8px' }}>
                      {g.reports?.map(r => (
                        <span key={r.id} style={styles.tag}>
                          {r.name}
                          <button onClick={() => handleRemoveReportFromGroup(g.id, r.id)} style={styles.tagRemove}>✕</button>
                        </span>
                      ))}
                    </div>
                    <select style={styles.selectSmall} onChange={e => { if (e.target.value) handleAddReportToGroup(g.id, parseInt(e.target.value)); e.target.value = ''; }}>
                      <option value="">+ Rapor Ekle</option>
                      {reports
                        .filter(r => r.environment === g.environment && !g.reports?.find(gr => gr.id === r.id))
                        .map(r => (
                          <option key={r.id} value={r.id}>{r.name}</option>
                        ))}
                    </select>
                    {reports.filter(r => r.environment === g.environment).length === 0 && (
                      <p style={{ fontSize: '12px', color: '#94a3b8', marginTop: '6px' }}>Bu ortam için henüz rapor tanımlanmamış.</p>
                    )}
                  </div>
                </div>
              ))}
              <Pagination currentPage={groupPage} total={totalPages(filteredGroups)} onPageChange={setGroupPage} />
            </div>
          </div>
        )}

        {/* RAPORLAR */}
        {activeTab === 'reports' && !loading && (
          <div>
            <div style={styles.card}>
              <h3 style={styles.cardTitle}>Yeni Rapor Ekle</h3>
              <form onSubmit={handleCreateReport} style={styles.form}>
                {isSuperAdmin && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <label style={styles.label}>Tenant</label>
                    <select style={styles.input} value={newReportTenantId} onChange={e => setNewReportTenantId(e.target.value)} required>
                      <option value="">Tenant Seçin...</option>
                      {tenants.filter(t => t.isActive).map(t => (
                        <option key={t.id} value={t.id}>{t.name}</option>
                      ))}
                    </select>
                  </div>
                )}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <label style={styles.label}>Ortam</label>
                  <select style={styles.input} value={newReportEnv} onChange={e => setNewReportEnv(e.target.value)}>
                    <option value="prod">🚀 Production</option>
                    <option value="test">🧪 Test</option>
                  </select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <label style={styles.label}>Power BI Raporu</label>
                  {isSuperAdmin && !newReportTenantId ? (
                    <div style={{ ...styles.input, color: '#94a3b8', backgroundColor: '#f9fafb' }}>Önce tenant seçin</div>
                  ) : powerBiLoading ? (
                    <div style={{ ...styles.input, color: '#94a3b8', backgroundColor: '#f9fafb' }}>Yükleniyor...</div>
                  ) : (
                    <select style={{ ...styles.input, minWidth: '300px' }} value={newReportId} onChange={e => { const selected = powerBiReports.find(r => r.id === e.target.value); if (selected) { setNewReportId(selected.id); setNewReportName(selected.name); } }} required>
                      <option value="">{powerBiReports.length === 0 ? 'Bu ortamda rapor bulunamadı' : `Rapor Seçin... (${powerBiReports.filter(pbr => !reports.find(r => r.powerBiReportId === pbr.id)).length} yeni)`}</option>
                      {powerBiReports.filter(pbr => !reports.find(r => r.powerBiReportId === pbr.id)).map(r => (
                        <option key={r.id} value={r.id}>{r.name}</option>
                      ))}
                    </select>
                  )}
                </div>
                <input placeholder="Rapor Adı" value={newReportName} onChange={e => setNewReportName(e.target.value)} style={styles.input} required />
                <input placeholder="Açıklama (opsiyonel)" value={newReportDesc} onChange={e => setNewReportDesc(e.target.value)} style={styles.input} />
                <button type="submit" style={styles.primaryButton}>Ekle</button>
              </form>
            </div>
            <div style={styles.card}>
              <div style={styles.tableHeader}>
                <h3 style={styles.cardTitle}>Raporlar ({filteredReports.length})</h3>
                <input placeholder="🔍 Rapor ara..." value={reportSearch} onChange={e => { setReportSearch(e.target.value); setReportPage(1); }} style={styles.searchInput} />
              </div>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Rapor Adı</th>
                    <th style={styles.th}>Ortam</th>
                    <th style={styles.th}>Açıklama</th>
                    <th style={styles.th}>Durum</th>
                    {isSuperAdmin && <th style={styles.th}>Tenant</th>}
                    <th style={styles.th}>AI Model</th>
                  </tr>
                </thead>
                <tbody>
                  {paginate(filteredReports, reportPage).map(r => (
                    <tr key={r.id}>
                      <td style={styles.td}>{r.name}</td>
                      <td style={styles.td}><EnvBadge env={r.environment} /></td>
                      <td style={styles.td}>{r.description || '-'}</td>
                      <td style={styles.td}><span style={{ color: r.isActive ? 'green' : 'red' }}>{r.isActive ? 'Aktif' : 'Pasif'}</span></td>
                      {isSuperAdmin && <td style={styles.td}><span style={styles.tenantBadge}>{r.tenantName || '-'}</span></td>}
                      <td style={styles.td}>
                        <select style={styles.selectSmall} value={r.reportContextId || ''} onChange={e => handleAssignContext(r.id, e.target.value || 0)}>
                          <option value="">Model Seç...</option>
                          {reportContexts.map(c => (<option key={c.id} value={c.id}>{c.name}</option>))}
                        </select>
                        {r.reportContextName && <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '4px' }}>✓ {r.reportContextName}</div>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <Pagination currentPage={reportPage} total={totalPages(filteredReports)} onPageChange={setReportPage} />
            </div>
          </div>
        )}

        {/* AI MODELLER */}
        {activeTab === 'contexts' && !loading && (
          <div>
            <div style={styles.card}>
              <h3 style={styles.cardTitle}>{editingContext ? 'Context Düzenle' : 'Yeni AI Model Tanımı'}</h3>
              <form onSubmit={handleCreateContext} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <input placeholder="Model Adı" value={newContextName} onChange={e => setNewContextName(e.target.value)} style={styles.input} required />
                <div>
                  <p style={{ ...styles.label, marginBottom: '6px' }}>Dimension Tanımları</p>
                  <textarea value={newContextDimensions} onChange={e => setNewContextDimensions(e.target.value)} style={{ ...styles.input, width: '100%', minHeight: '120px', resize: 'vertical', fontFamily: 'monospace', fontSize: '13px' }} required />
                </div>
                <div>
                  <p style={{ ...styles.label, marginBottom: '6px' }}>Measure Tanımları</p>
                  <textarea value={newContextMeasures} onChange={e => setNewContextMeasures(e.target.value)} style={{ ...styles.input, width: '100%', minHeight: '120px', resize: 'vertical', fontFamily: 'monospace', fontSize: '13px' }} required />
                </div>
                <div>
                  <p style={{ ...styles.label, marginBottom: '6px' }}>AI Kuralları (opsiyonel)</p>
                  <textarea value={newContextRules} onChange={e => setNewContextRules(e.target.value)} style={{ ...styles.input, width: '100%', minHeight: '100px', resize: 'vertical', fontFamily: 'monospace', fontSize: '13px' }} />
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button type="submit" style={styles.primaryButton}>{editingContext ? 'Güncelle' : 'Oluştur'}</button>
                  {editingContext && (
                    <button type="button" style={styles.dangerButton} onClick={() => { setEditingContext(null); setNewContextName(''); setNewContextDimensions(''); setNewContextMeasures(''); setNewContextRules(''); }}>İptal</button>
                  )}
                </div>
              </form>
            </div>
            <div style={styles.card}>
              <div style={styles.tableHeader}>
                <h3 style={styles.cardTitle}>AI Modeller ({filteredContexts.length})</h3>
                <input placeholder="🔍 Model ara..." value={contextSearch} onChange={e => { setContextSearch(e.target.value); setContextPage(1); }} style={styles.searchInput} />
              </div>
              {paginate(filteredContexts, contextPage).map(c => (
                <div key={c.id} style={styles.groupCard}>
                  <div style={styles.groupHeader}>
                    <strong>{c.name}</strong>
                    <span style={styles.badge}>{c.reportCount} rapor</span>
                    <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
                      <button onClick={() => handleEditContext(c)} style={styles.primaryButton}>Düzenle</button>
                      <button onClick={() => handleDeleteContext(c.id)} style={styles.dangerButton}>Sil</button>
                    </div>
                  </div>
                  <div style={styles.groupBody}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                      <div>
                        <p style={styles.label}>Dimension Tanımları:</p>
                        <pre style={{ margin: 0, fontSize: '12px', color: '#374151', whiteSpace: 'pre-wrap', backgroundColor: '#f8fafc', padding: '8px', borderRadius: '4px' }}>{c.dimensionDefinitions}</pre>
                      </div>
                      <div>
                        <p style={styles.label}>Measure Tanımları:</p>
                        <pre style={{ margin: 0, fontSize: '12px', color: '#374151', whiteSpace: 'pre-wrap', backgroundColor: '#f8fafc', padding: '8px', borderRadius: '4px' }}>{c.measureDefinitions}</pre>
                      </div>
                      {c.systemPromptRules && (
                        <div style={{ gridColumn: '1 / -1' }}>
                          <p style={styles.label}>AI Kuralları:</p>
                          <pre style={{ margin: 0, fontSize: '12px', color: '#374151', whiteSpace: 'pre-wrap', backgroundColor: '#fff3cd', padding: '8px', borderRadius: '4px' }}>{c.systemPromptRules}</pre>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
              <Pagination currentPage={contextPage} total={totalPages(filteredContexts)} onPageChange={setContextPage} />
            </div>
          </div>
        )}

        {/* AI FEEDBACKS */}
        {activeTab === 'feedbacks' && !loading && (
          <div style={{ display: 'flex', gap: '16px' }}>
            <div style={{ flex: 1 }}>
              <div style={styles.card}>
                <div style={styles.tableHeader}>
                  <h3 style={styles.cardTitle}>AI Feedbacks ({filteredFeedbacks.length})</h3>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <input placeholder="🔍 Ara..." value={feedbackSearch} onChange={e => { setFeedbackSearch(e.target.value); setFeedbackPage(1); }} style={styles.searchInput} />
                    <button onClick={loadFeedbacks} style={styles.primaryButton}>Yenile</button>
                  </div>
                </div>
                {filteredFeedbacks.length === 0 ? (
                  <p style={{ color: '#94a3b8', textAlign: 'center', padding: '32px' }}>Henüz feedback yok.</p>
                ) : (
                  paginate(filteredFeedbacks, feedbackPage).map(f => (
                    <div key={f.id} onClick={() => setSelectedFeedback(f)} style={{ ...styles.feedbackItem, ...(selectedFeedback?.id === f.id ? styles.feedbackItemActive : {}) }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                        <span style={{ fontSize: '12px', color: '#64748b' }}>{f.userEmail}</span>
                        <span style={{ fontSize: '11px', color: '#94a3b8' }}>{new Date(f.createdAt).toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</span>
                      </div>
                      <div style={{ fontSize: '13px', color: '#1e293b', fontWeight: '500', marginBottom: '4px' }}>{f.userMessage?.substring(0, 80)}{f.userMessage?.length > 80 ? '...' : ''}</div>
                      {f.userComment && <div style={{ fontSize: '12px', color: '#ef4444' }}>💬 {f.userComment}</div>}
                    </div>
                  ))
                )}
                <Pagination currentPage={feedbackPage} total={totalPages(filteredFeedbacks)} onPageChange={setFeedbackPage} />
              </div>
            </div>
            {selectedFeedback && (
              <div style={{ width: '480px' }}>
                <div style={styles.card}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                    <h3 style={styles.cardTitle}>Detay</h3>
                    <button onClick={() => setSelectedFeedback(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px', color: '#64748b' }}>✕</button>
                  </div>
                  <div style={styles.feedbackDetail}>
                    <div style={styles.detailRow}><span style={styles.detailLabel}>Kullanıcı</span><span style={styles.detailValue}>{selectedFeedback.userEmail}</span></div>
                    <div style={styles.detailRow}><span style={styles.detailLabel}>Tarih</span><span style={styles.detailValue}>{new Date(selectedFeedback.createdAt).toLocaleString('tr-TR')}</span></div>
                    <div style={styles.detailRow}><span style={styles.detailLabel}>Rapor ID</span><span style={styles.detailValue}>{selectedFeedback.reportId || '-'}</span></div>
                  </div>
                  <div style={styles.detailSection}><p style={styles.detailSectionTitle}>👤 Kullanıcı Sorusu</p><div style={styles.detailBox}>{selectedFeedback.userMessage}</div></div>
                  <div style={styles.detailSection}><p style={styles.detailSectionTitle}>🤖 AI Cevabı</p><div style={styles.detailBox}>{selectedFeedback.aiResponse}</div></div>
                  {selectedFeedback.userComment && <div style={styles.detailSection}><p style={styles.detailSectionTitle}>💬 Kullanıcı Yorumu</p><div style={{ ...styles.detailBox, backgroundColor: '#fef2f2', borderColor: '#fecaca' }}>{selectedFeedback.userComment}</div></div>}
                  {selectedFeedback.activeFilters && <div style={styles.detailSection}><p style={styles.detailSectionTitle}>🔍 Aktif Filtreler</p><div style={styles.detailBox}>{selectedFeedback.activeFilters}</div></div>}
                  {selectedFeedback.conversationHistory && (
                    <div style={styles.detailSection}>
                      <p style={styles.detailSectionTitle}>📜 Conversation History</p>
                      <div style={{ ...styles.detailBox, maxHeight: '200px', overflowY: 'auto', fontFamily: 'monospace', fontSize: '11px' }}>
                        {(() => {
                          try {
                            const history = JSON.parse(selectedFeedback.conversationHistory);
                            return history.map((h, i) => (
                              <div key={i} style={{ marginBottom: '8px', padding: '4px', backgroundColor: h.role === 'user' ? '#eff6ff' : '#f0fdf4', borderRadius: '4px' }}>
                                <strong>{h.role === 'user' ? '👤' : '🤖'}</strong> {h.content?.substring(0, 200)}{h.content?.length > 200 ? '...' : ''}
                              </div>
                            ));
                          } catch { return <span>{selectedFeedback.conversationHistory}</span>; }
                        })()}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {/* MASTER DATA */}
        {activeTab === 'masterdata' && !loading && (
          <div>
            {isSuperAdmin && (
              <div style={styles.card}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <label style={{ ...styles.label, margin: 0, fontWeight: '600' }}>Tenant Seç:</label>
                  <select style={{ ...styles.input, minWidth: '250px' }} value={mdTenantId} onChange={e => setMdTenantId(e.target.value)}>
                    <option value="">Tenant Seçin...</option>
                    {tenants.filter(t => t.isActive).map(t => (
                      <option key={t.id} value={t.id}>{t.name} ({t.schemaName || 'schema yok'})</option>
                    ))}
                  </select>
                  {mdTenantId && (
                    <button style={styles.primaryButton} onClick={() => loadMasterData(mdTenantId)}>🔄 Yenile</button>
                  )}
                </div>
                {isSuperAdmin && !mdTenantId && (
                  <p style={{ color: '#94a3b8', fontSize: '13px', margin: '8px 0 0 0' }}>Master data yönetmek için tenant seçin.</p>
                )}
              </div>
            )}

            {(!isSuperAdmin || mdTenantId) && (
              <>
                <div style={{ ...styles.tabs, marginBottom: '16px', backgroundColor: '#f8fafc', borderRadius: '8px' }}>
                  {[
                    { key: 'salesforce', label: '📥 Toplu Yükleme' },
                    { key: 'teams', label: `👥 Ekipler (${teams.length})` },
                    { key: 'regions', label: `🗺️ Bölgeler (${regions.length})` },
                    { key: 'reps', label: `👤 Temsilciler (${reps.length})` },
                    { key: 'bricks', label: `📍 Brick Atamaları (${repBricks.length})` },
                    { key: 'markets', label: `🏪 Pazarlar (${markets.length})` },
                    { key: 'products', label: `💊 Ürünler (${products.length})` },
                  ].map(st => (
                    <button key={st.key} style={{ ...styles.tab, ...(mdSubTab === st.key ? styles.tabActive : {}) }} onClick={() => setMdSubTab(st.key)}>
                      {st.label}
                    </button>
                  ))}
                </div>

                {mdLoading && <p style={{ color: '#94a3b8', padding: '16px' }}>Yükleniyor...</p>}

                {!mdLoading && (
                  <>
                    {/* ── TOPLU YÜKLEME ── */}
                    {mdSubTab === 'salesforce' && (
                      <div>
                        {/* ── Saha Ekibi Yükleme ── */}
                        <div style={styles.card}>
                          <h3 style={styles.cardTitle}>📥 Saha Ekibi Toplu Yükleme</h3>
                          <p style={{ fontSize: '13px', color: '#64748b', marginBottom: '16px' }}>
                            Excel formatı: <strong>Team, Region, SalesRepUniqueId, SalesRep, Brick, Salespercent, StartDate, EndDate, WhiteFlag</strong>
                          </p>
                          <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '16px' }}>
                            <input
                              type="file"
                              accept=".xlsx"
                              onChange={e => { setBulkFile(e.target.files[0]); setBulkErrors([]); setBulkResult(null); }}
                              style={{ fontSize: '14px' }}
                            />
                            <button
                              style={{ ...styles.primaryButton, opacity: bulkImporting || !bulkFile ? 0.6 : 1 }}
                              disabled={bulkImporting || !bulkFile}
                              onClick={async () => {
                                if (!bulkFile) return;
                                setBulkImporting(true);
                                setBulkErrors([]);
                                setBulkResult(null);
                                try {
                                  const tid = isSuperAdmin ? mdTenantId : null;
                                  const result = await bulkImportSalesForce(bulkFile, tid || null);
                                  setBulkResult(result);
                                  setMessage(`✅ ${result.insertedCount} kayıt eklendi, ${result.closedCount} kayıt kapatıldı.`);
                                  loadMasterData(isSuperAdmin ? mdTenantId : null);
                                } catch (err) {
                                  const errors = err.response?.data?.errors || [];
                                  setBulkErrors(errors);
                                  setMessage('❌ Validasyon hataları bulundu. Lütfen Excel\'i düzeltin.');
                                } finally {
                                  setBulkImporting(false);
                                }
                              }}
                            >
                              {bulkImporting ? 'Yükleniyor...' : '📤 Yükle'}
                            </button>
                          </div>

                          {bulkResult && (
                            <div style={{ backgroundColor: '#dcfce7', border: '1px solid #86efac', borderRadius: '6px', padding: '12px 16px', marginBottom: '16px' }}>
                              <strong style={{ color: '#166534' }}>✅ Import tamamlandı</strong>
                              <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: '#166534' }}>
                                {bulkResult.insertedCount} kayıt eklendi, {bulkResult.closedCount} kayıt kapatıldı.
                              </p>
                            </div>
                          )}

                          {bulkErrors.length > 0 && (
                            <div>
                              <div style={{ backgroundColor: '#fef2f2', border: '1px solid #fecaca', borderRadius: '6px', padding: '12px 16px', marginBottom: '12px' }}>
                                <strong style={{ color: '#991b1b' }}>❌ {bulkErrors.length} hata bulundu</strong>
                                <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: '#991b1b' }}>Aşağıdaki hataları Excel'de düzeltin ve tekrar yükleyin.</p>
                              </div>
                              <table style={styles.table}>
                                <thead>
                                  <tr>
                                    <th style={styles.th}>Satır</th>
                                    <th style={styles.th}>Kolon</th>
                                    <th style={styles.th}>Hata</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {bulkErrors.map((err, i) => (
                                    <tr key={i}>
                                      <td style={{ ...styles.td, color: '#ef4444', fontWeight: '600' }}>{err.rowNumber === 0 ? 'Genel' : `Satır ${err.rowNumber}`}</td>
                                      <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px' }}>{err.column}</td>
                                      <td style={styles.td}>{err.message}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>

                        {/* ── YENİ: Ürün & Pazar Yükleme ── */}
                        <div style={styles.card}>
                          <h3 style={styles.cardTitle}>💊 Ürün & Pazar Toplu Yükleme</h3>
                          <p style={{ fontSize: '13px', color: '#64748b', marginBottom: '16px' }}>
                            Excel formatı: <strong>TEAM | MARKET | IMSPRODUCT | PRODUCTSHORT | PRODUCTGROUPNAME | AVIXAPRODUCT | TARGETINCLUDED | SU MULTIPLIER | Group | Promo/Non Promo</strong>
                          </p>

                          <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '16px' }}>
                            <input
                              type="file"
                              accept=".xlsx"
                              onChange={e => {
                                setPmFile(e.target.files[0] || null);
                                setPmResult(null);
                                setPmErrors([]);
                              }}
                              style={{ fontSize: '14px' }}
                            />
                            <button
                              style={{ ...styles.primaryButton, opacity: pmLoading || !pmFile ? 0.6 : 1 }}
                              disabled={pmLoading || !pmFile}
                              onClick={handleBulkImportProductsMarkets}
                            >
                              {pmLoading ? 'Yükleniyor...' : '📤 Yükle'}
                            </button>
                          </div>

                          {/* Başarı özeti */}
                          {pmResult && (
                            <div style={{ backgroundColor: '#dcfce7', border: '1px solid #86efac', borderRadius: '6px', padding: '12px 16px', marginBottom: '16px' }}>
                              <strong style={{ color: '#166534' }}>✅ İçe aktarma tamamlandı</strong>
                              <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px', color: '#166534', fontSize: '13px' }}>
                                <li>Oluşturulan pazar: <strong>{pmResult.marketsCreated}</strong></li>
                                <li>Eklenen ürün: <strong>{pmResult.productsInserted}</strong></li>
                                <li>Güncellenen ürün: <strong>{pmResult.productsUpdated}</strong></li>
                                <li>Kurulan ürün-pazar ilişkisi: <strong>{pmResult.relationsCreated}</strong></li>
                              </ul>
                            </div>
                          )}

                          {/* Hata listesi */}
                          {pmErrors.length > 0 && (
                            <div>
                              <div style={{ backgroundColor: '#fef2f2', border: '1px solid #fecaca', borderRadius: '6px', padding: '12px 16px', marginBottom: '12px' }}>
                                <strong style={{ color: '#991b1b' }}>❌ {pmErrors.length} hata bulundu</strong>
                                <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: '#991b1b' }}>Aşağıdaki hataları Excel'de düzeltin ve tekrar yükleyin.</p>
                              </div>
                              <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '13px', color: '#991b1b' }}>
                                  {pmErrors.map((e, i) => <li key={i}>{e}</li>)}
                                </ul>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {/* ── EKİPLER ── */}
                    {mdSubTab === 'teams' && (
                      <div>
                        <div style={styles.card}>
                          <h3 style={styles.cardTitle}>Yeni Ekip Ekle</h3>
                          <div style={styles.form}>
                            <input placeholder="Ekip Adı (örn: BEYAZ)" value={newTeamName} onChange={e => setNewTeamName(e.target.value)} style={styles.input} />
                            <button style={styles.primaryButton} onClick={async () => {
                              if (!newTeamName.trim()) return;
                              try {
                                await createTeam(newTeamName.trim(), isSuperAdmin ? mdTenantId : null);
                                setNewTeamName('');
                                setMessage('Ekip oluşturuldu.');
                                loadMasterData(isSuperAdmin ? mdTenantId : null);
                              } catch { setMessage('İşlem başarısız.'); }
                            }}>Ekle</button>
                          </div>
                        </div>
                        <div style={styles.card}>
                          <h3 style={styles.cardTitle}>Ekipler ({teams.length})</h3>
                          <table style={styles.table}>
                            <thead><tr><th style={styles.th}>Ekip Adı</th><th style={styles.th}>Oluşturma</th><th style={styles.th}>İşlem</th></tr></thead>
                            <tbody>
                              {teams.map(t => (
                                <tr key={t.id}>
                                  <td style={styles.td}><strong>{t.teamName}</strong></td>
                                  <td style={styles.td}>{new Date(t.createdAt).toLocaleDateString('tr-TR')}</td>
                                  <td style={styles.td}>
                                    <button style={styles.dangerButton} onClick={async () => {
                                      if (!window.confirm(`"${t.teamName}" ekibini silmek istiyor musunuz?`)) return;
                                      try {
                                        await deleteTeam(t.id, isSuperAdmin ? mdTenantId : null);
                                        setMessage('Ekip silindi.');
                                        loadMasterData(isSuperAdmin ? mdTenantId : null);
                                      } catch { setMessage('İşlem başarısız.'); }
                                    }}>Sil</button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {/* ── BÖLGELER ── */}
                    {mdSubTab === 'regions' && (
                      <div>
                        <div style={styles.card}>
                          <h3 style={styles.cardTitle}>Yeni Bölge Ekle</h3>
                          <div style={styles.form}>
                            <select style={styles.input} value={newRegionTeamId} onChange={e => setNewRegionTeamId(e.target.value)}>
                              <option value="">Ekip Seçin...</option>
                              {teams.map(t => <option key={t.id} value={t.id}>{t.teamName}</option>)}
                            </select>
                            <input placeholder="Bölge Adı (örn: ANKARA)" value={newRegionName} onChange={e => setNewRegionName(e.target.value)} style={styles.input} />
                            <button style={styles.primaryButton} onClick={async () => {
                              if (!newRegionName.trim() || !newRegionTeamId) return;
                              try {
                                await createRegion(newRegionName.trim(), parseInt(newRegionTeamId), isSuperAdmin ? mdTenantId : null);
                                setNewRegionName('');
                                setMessage('Bölge oluşturuldu.');
                                loadMasterData(isSuperAdmin ? mdTenantId : null);
                              } catch { setMessage('İşlem başarısız.'); }
                            }}>Ekle</button>
                          </div>
                        </div>
                        <div style={styles.card}>
                          <h3 style={styles.cardTitle}>Bölgeler ({regions.length})</h3>
                          <table style={styles.table}>
                            <thead><tr><th style={styles.th}>Bölge Adı</th><th style={styles.th}>Ekip</th><th style={styles.th}>İşlem</th></tr></thead>
                            <tbody>
                              {regions.map(r => (
                                <tr key={r.id}>
                                  <td style={styles.td}><strong>{r.regionName}</strong></td>
                                  <td style={styles.td}><span style={styles.tenantBadge}>{r.teamName}</span></td>
                                  <td style={styles.td}>
                                    <button style={styles.dangerButton} onClick={async () => {
                                      if (!window.confirm(`"${r.regionName}" bölgesini silmek istiyor musunuz?`)) return;
                                      try {
                                        await deleteRegion(r.id, isSuperAdmin ? mdTenantId : null);
                                        setMessage('Bölge silindi.');
                                        loadMasterData(isSuperAdmin ? mdTenantId : null);
                                      } catch { setMessage('İşlem başarısız.'); }
                                    }}>Sil</button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {/* ── TEMSİLCİLER ── */}
                    {mdSubTab === 'reps' && (
                      <div>
                        <div style={styles.card}>
                          <h3 style={styles.cardTitle}>Yeni Temsilci Ekle</h3>
                          <div style={styles.form}>
                            <select style={styles.input} value={newRepRegionId} onChange={e => setNewRepRegionId(e.target.value)}>
                              <option value="">Bölge Seçin...</option>
                              {regions.map(r => <option key={r.id} value={r.id}>{r.teamName} → {r.regionName}</option>)}
                            </select>
                            <input placeholder="Temsilci Adı" value={newRepName} onChange={e => setNewRepName(e.target.value)} style={styles.input} />
                            <input placeholder="Temsilci Kodu (opsiyonel)" value={newRepCode} onChange={e => setNewRepCode(e.target.value)} style={{ ...styles.input, minWidth: '160px' }} />
                            <button style={styles.primaryButton} onClick={async () => {
                              if (!newRepName.trim() || !newRepRegionId) return;
                              try {
                                await createRep(newRepName.trim(), newRepCode.trim() || null, parseInt(newRepRegionId), isSuperAdmin ? mdTenantId : null);
                                setNewRepName(''); setNewRepCode('');
                                setMessage('Temsilci oluşturuldu.');
                                loadMasterData(isSuperAdmin ? mdTenantId : null);
                              } catch { setMessage('İşlem başarısız.'); }
                            }}>Ekle</button>
                          </div>
                        </div>
                        <div style={styles.card}>
                          <h3 style={styles.cardTitle}>Temsilciler ({reps.length})</h3>
                          <table style={styles.table}>
                            <thead><tr><th style={styles.th}>Temsilci</th><th style={styles.th}>Kod</th><th style={styles.th}>Bölge</th><th style={styles.th}>Ekip</th><th style={styles.th}>İşlem</th></tr></thead>
                            <tbody>
                              {reps.map(r => (
                                <tr key={r.id}>
                                  <td style={styles.td}><strong>{r.repName}</strong></td>
                                  <td style={styles.td}><span style={{ fontFamily: 'monospace', fontSize: '12px' }}>{r.repCode || '-'}</span></td>
                                  <td style={styles.td}>{r.regionName}</td>
                                  <td style={styles.td}><span style={styles.tenantBadge}>{r.teamName}</span></td>
                                  <td style={styles.td}>
                                    <button style={styles.dangerButton} onClick={async () => {
                                      if (!window.confirm(`"${r.repName}" temsilcisini silmek istiyor musunuz?`)) return;
                                      try {
                                        await deleteRep(r.id, isSuperAdmin ? mdTenantId : null);
                                        setMessage('Temsilci silindi.');
                                        loadMasterData(isSuperAdmin ? mdTenantId : null);
                                      } catch { setMessage('İşlem başarısız.'); }
                                    }}>Sil</button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {/* ── BRICK ATAMALARI ── */}
                    {mdSubTab === 'bricks' && (
                      <BrickAssignmentPanel
                        repBricks={repBricks} teams={teams} regions={regions} reps={reps}
                        tid={isSuperAdmin ? mdTenantId : null} isSuperAdmin={isSuperAdmin}
                        mdTenantId={mdTenantId} loadMasterData={loadMasterData}
                        setMessage={setMessage} styles={styles}
                      />
                    )}

                    {/* ── PAZARLAR ── */}
                    {mdSubTab === 'markets' && (
                      <div>
                        <div style={styles.card}>
                          <h3 style={styles.cardTitle}>Yeni Pazar Ekle</h3>
                          <div style={styles.form}>
                            <select style={styles.input} value={newMarketTeamId} onChange={e => setNewMarketTeamId(e.target.value)}>
                              <option value="">Ekip Seçin...</option>
                              {teams.map(t => <option key={t.id} value={t.id}>{t.teamName}</option>)}
                            </select>
                            <input placeholder="Pazar Adı (örn: PLAVIX)" value={newMarketName} onChange={e => setNewMarketName(e.target.value)} style={styles.input} />
                            <button style={styles.primaryButton} onClick={async () => {
                              if (!newMarketName.trim() || !newMarketTeamId) return;
                              try {
                                await createMarket(newMarketName.trim(), parseInt(newMarketTeamId), isSuperAdmin ? mdTenantId : null);
                                setNewMarketName('');
                                setMessage('Pazar oluşturuldu.');
                                loadMasterData(isSuperAdmin ? mdTenantId : null);
                              } catch { setMessage('İşlem başarısız.'); }
                            }}>Ekle</button>
                          </div>
                        </div>
                        <div style={styles.card}>
                          <h3 style={styles.cardTitle}>Pazarlar ({markets.length})</h3>
                          <table style={styles.table}>
                            <thead><tr><th style={styles.th}>Pazar Adı</th><th style={styles.th}>Ekip</th><th style={styles.th}>İşlem</th></tr></thead>
                            <tbody>
                              {markets.map(m => (
                                <tr key={m.id}>
                                  <td style={styles.td}><strong>{m.marketName}</strong></td>
                                  <td style={styles.td}><span style={styles.tenantBadge}>{m.teamName}</span></td>
                                  <td style={styles.td}>
                                    <button style={styles.dangerButton} onClick={async () => {
                                      if (!window.confirm(`"${m.marketName}" pazarını silmek istiyor musunuz?`)) return;
                                      try {
                                        await deleteMarket(m.id, isSuperAdmin ? mdTenantId : null);
                                        setMessage('Pazar silindi.');
                                        loadMasterData(isSuperAdmin ? mdTenantId : null);
                                      } catch { setMessage('İşlem başarısız.'); }
                                    }}>Sil</button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {/* ── ÜRÜNLER ── */}
                    {mdSubTab === 'products' && (
                      <div style={styles.card}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                          <h3 style={{ ...styles.cardTitle, margin: 0 }}>💊 Ürünler ({products.length})</h3>
                          <button style={styles.primaryButton} onClick={async () => {
                            try {
                              const changed = products.filter(p => p._dirty);
                              if (changed.length === 0) { setMessage('Değişiklik yok.'); return; }
                              await bulkUpdateProducts(changed.map(p => ({
                                id: p.id,
                                avixaProductName: p.avixaProductName,
                                productGroupName: p.productGroupName,
                                isVisible: p.isVisible,
                                isAvixaProduct: p.isAvixaProduct,
                                targetIncluded: p.targetIncluded,
                                suMultiplier: p.suMultiplier,
                                groupType: p.groupType,
                                promoFlag: p.promoFlag
                              })), isSuperAdmin ? mdTenantId : null);
                              setMessage(`${changed.length} ürün güncellendi.`);
                              loadMasterData(isSuperAdmin ? mdTenantId : null);
                            } catch { setMessage('İşlem başarısız.'); }
                          }}>💾 Değişiklikleri Kaydet</button>
                        </div>
                        <p style={{ fontSize: '12px', color: '#94a3b8', marginBottom: '12px' }}>Hücreleri tıklayarak düzenleyin. Değişen satırlar sarı ile işaretlenir.</p>
                        <div style={{ overflowX: 'auto' }}>
                          <table style={{ ...styles.table, fontSize: '12px' }}>
                            <thead>
                              <tr>
                                <th style={styles.th}>IMS Ürün Adı</th>
                                <th style={styles.th}>Avixa Ürün Adı</th>
                                <th style={styles.th}>Ürün Grubu</th>
                                <th style={styles.th}>Görünür</th>
                                <th style={styles.th}>Avixa Ürünü</th>
                                <th style={styles.th}>Hedef</th>
                                <th style={styles.th}>SU Çarpan</th>
                                <th style={styles.th}>Grup Tipi</th>
                                <th style={styles.th}>Promo</th>
                                <th style={styles.th}>Pazarlar</th>
                              </tr>
                            </thead>
                            <tbody>
                              {products.map((p, idx) => (
                                <tr key={p.id} style={{ backgroundColor: p._dirty ? '#fefce8' : 'transparent' }}>
                                  <td style={{ ...styles.td, color: '#64748b', fontSize: '11px' }}>{p.imsProductName}</td>
                                  <td style={styles.td}><input value={p.avixaProductName || ''} onChange={e => { const u = [...products]; u[idx] = { ...u[idx], avixaProductName: e.target.value, _dirty: true }; setProducts(u); }} style={{ border: '1px solid #e2e8f0', borderRadius: '4px', padding: '3px 6px', fontSize: '12px', width: '140px' }} /></td>
                                  <td style={styles.td}><input value={p.productGroupName || ''} onChange={e => { const u = [...products]; u[idx] = { ...u[idx], productGroupName: e.target.value, _dirty: true }; setProducts(u); }} style={{ border: '1px solid #e2e8f0', borderRadius: '4px', padding: '3px 6px', fontSize: '12px', width: '140px' }} /></td>
                                  <td style={{ ...styles.td, textAlign: 'center' }}><input type="checkbox" checked={p.isVisible} onChange={e => { const u = [...products]; u[idx] = { ...u[idx], isVisible: e.target.checked, _dirty: true }; setProducts(u); }} /></td>
                                  <td style={{ ...styles.td, textAlign: 'center' }}><input type="checkbox" checked={p.isAvixaProduct} onChange={e => { const u = [...products]; u[idx] = { ...u[idx], isAvixaProduct: e.target.checked, _dirty: true }; setProducts(u); }} /></td>
                                  <td style={{ ...styles.td, textAlign: 'center' }}><input type="checkbox" checked={p.targetIncluded} onChange={e => { const u = [...products]; u[idx] = { ...u[idx], targetIncluded: e.target.checked, _dirty: true }; setProducts(u); }} /></td>
                                  <td style={styles.td}><input type="number" step="0.01" value={p.suMultiplier} onChange={e => { const u = [...products]; u[idx] = { ...u[idx], suMultiplier: parseFloat(e.target.value) || 1, _dirty: true }; setProducts(u); }} style={{ border: '1px solid #e2e8f0', borderRadius: '4px', padding: '3px 6px', fontSize: '12px', width: '70px' }} /></td>
                                  <td style={styles.td}><select value={p.groupType || ''} onChange={e => { const u = [...products]; u[idx] = { ...u[idx], groupType: e.target.value || null, _dirty: true }; setProducts(u); }} style={{ border: '1px solid #e2e8f0', borderRadius: '4px', padding: '3px 6px', fontSize: '12px' }}><option value="">-</option><option value="Marketing">Marketing</option><option value="AVİXA">AVİXA</option></select></td>
                                  <td style={styles.td}><select value={p.promoFlag || ''} onChange={e => { const u = [...products]; u[idx] = { ...u[idx], promoFlag: e.target.value || null, _dirty: true }; setProducts(u); }} style={{ border: '1px solid #e2e8f0', borderRadius: '4px', padding: '3px 6px', fontSize: '12px' }}><option value="">-</option><option value="Promo">Promo</option><option value="Non-Promo">Non-Promo</option></select></td>
                                  <td style={{ ...styles.td, fontSize: '11px', color: '#64748b' }}>{p.markets || '-'}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        )}

        {/* TENANTS */}
        {activeTab === 'tenants' && isSuperAdmin && !loading && (
          <div>
            <div style={styles.card}>
              <h3 style={styles.cardTitle}>{editingTenant ? 'Tenant Düzenle' : 'Yeni Tenant Ekle'}</h3>
              <form onSubmit={handleCreateTenant} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  <input placeholder="Tenant Adı" value={newTenantName} onChange={e => setNewTenantName(e.target.value)} style={styles.input} required />
                  <input placeholder="Açıklama (opsiyonel)" value={newTenantDesc} onChange={e => setNewTenantDesc(e.target.value)} style={{ ...styles.input, flex: 1 }} />
                </div>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  <input placeholder="Power BI Workspace ID (prod)" value={newTenantWorkspaceId} onChange={e => setNewTenantWorkspaceId(e.target.value)} style={{ ...styles.input, flex: 1, fontFamily: 'monospace' }} required />
                  <input placeholder="Power BI Workspace ID (test, opsiyonel)" value={newTenantTestWorkspaceId} onChange={e => setNewTenantTestWorkspaceId(e.target.value)} style={{ ...styles.input, flex: 1, fontFamily: 'monospace' }} />
                </div>
                <p style={{ ...styles.label, marginBottom: '0', fontWeight: '600' }}>🎨 Marka Ayarları</p>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <label style={styles.label}>Ana Renk</label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <input type="color" value={newTenantPrimaryColor} onChange={e => setNewTenantPrimaryColor(e.target.value)} style={{ width: '48px', height: '36px', padding: '2px', border: '1px solid #d1d5db', borderRadius: '4px', cursor: 'pointer' }} />
                      <input value={newTenantPrimaryColor} onChange={e => setNewTenantPrimaryColor(e.target.value)} style={{ ...styles.input, minWidth: '100px', fontFamily: 'monospace' }} />
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <label style={styles.label}>İkincil Renk</label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <input type="color" value={newTenantSecondaryColor} onChange={e => setNewTenantSecondaryColor(e.target.value)} style={{ width: '48px', height: '36px', padding: '2px', border: '1px solid #d1d5db', borderRadius: '4px', cursor: 'pointer' }} />
                      <input value={newTenantSecondaryColor} onChange={e => setNewTenantSecondaryColor(e.target.value)} style={{ ...styles.input, minWidth: '100px', fontFamily: 'monospace' }} />
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                    <label style={styles.label}>Portal Başlığı</label>
                    <input placeholder="Avixa Analitik Portal" value={newTenantPortalTitle} onChange={e => setNewTenantPortalTitle(e.target.value)} style={styles.input} />
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                    <label style={styles.label}>Logo URL</label>
                    <input placeholder="https://..." value={newTenantLogoUrl} onChange={e => setNewTenantLogoUrl(e.target.value)} style={styles.input} />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                    <label style={styles.label}>Favicon URL</label>
                    <input placeholder="https://..." value={newTenantFaviconUrl} onChange={e => setNewTenantFaviconUrl(e.target.value)} style={styles.input} />
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button type="submit" style={styles.primaryButton}>{editingTenant ? 'Güncelle' : 'Oluştur'}</button>
                  {editingTenant && (
                    <button type="button" style={styles.dangerButton} onClick={() => {
                      setEditingTenant(null);
                      setNewTenantName(''); setNewTenantDesc('');
                      setNewTenantWorkspaceId(''); setNewTenantTestWorkspaceId('');
                      setNewTenantPrimaryColor('#1a1a2e'); setNewTenantSecondaryColor('#2e75b6');
                      setNewTenantLogoUrl(''); setNewTenantFaviconUrl(''); setNewTenantPortalTitle('');
                    }}>İptal</button>
                  )}
                </div>
              </form>
            </div>
            <div style={styles.card}>
              <div style={styles.tableHeader}>
                <h3 style={styles.cardTitle}>Tenants ({filteredTenants.length})</h3>
                <input placeholder="🔍 Tenant ara..." value={tenantSearch} onChange={e => { setTenantSearch(e.target.value); setTenantPage(1); }} style={styles.searchInput} />
              </div>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Tenant Adı</th>
                    <th style={styles.th}>Açıklama</th>
                    <th style={styles.th}>Prod Workspace</th>
                    <th style={styles.th}>Test Workspace</th>
                    <th style={styles.th}>Kullanıcı</th>
                    <th style={styles.th}>Rapor</th>
                    <th style={styles.th}>Durum</th>
                    <th style={styles.th}>İşlem</th>
                  </tr>
                </thead>
                <tbody>
                  {paginate(filteredTenants, tenantPage).map(t => (
                    <tr key={t.id}>
                      <td style={styles.td}><strong>{t.name}</strong></td>
                      <td style={styles.td}>{t.description || '-'}</td>
                      <td style={styles.td} title={t.powerBiWorkspaceId}><span style={{ fontFamily: 'monospace', fontSize: '12px' }}>{t.powerBiWorkspaceId?.substring(0, 8)}...</span></td>
                      <td style={styles.td} title={t.powerBiTestWorkspaceId}>{t.powerBiTestWorkspaceId ? <span style={{ fontFamily: 'monospace', fontSize: '12px' }}>{t.powerBiTestWorkspaceId?.substring(0, 8)}...</span> : <span style={{ color: '#94a3b8' }}>-</span>}</td>
                      <td style={styles.td}><span style={styles.badge}>{t.userCount}</span></td>
                      <td style={styles.td}><span style={styles.badge}>{t.reportCount}</span></td>
                      <td style={styles.td}><span style={{ color: t.isActive ? 'green' : 'red', fontWeight: '500' }}>{t.isActive ? 'Aktif' : 'Pasif'}</span></td>
                      <td style={styles.td}>
                        <div style={{ display: 'flex', gap: '6px' }}>
                          <button onClick={() => handleEditTenant(t)} style={{ ...styles.primaryButton, fontSize: '12px', padding: '4px 10px' }}>Düzenle</button>
                          <button onClick={() => handleToggleTenant(t.id)} style={{ ...styles.primaryButton, backgroundColor: t.isActive ? '#f59e0b' : '#22c55e', fontSize: '12px', padding: '4px 10px' }}>{t.isActive ? 'Pasif Et' : 'Aktif Et'}</button>
                          <button onClick={() => handleDeleteTenant(t.id)} style={styles.dangerButton}>Sil</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <Pagination currentPage={tenantPage} total={totalPages(filteredTenants)} onPageChange={setTenantPage} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', backgroundColor: '#f0f2f5' },
  header: { backgroundColor: '#1a1a2e', padding: '12px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  headerLeft: { display: 'flex', alignItems: 'center', gap: '12px' },
  headerRight: { display: 'flex', alignItems: 'center', gap: '12px' },
  title: { color: 'white', margin: 0, fontSize: '18px' },
  superAdminBadge: { backgroundColor: '#f59e0b', color: '#1a1a2e', padding: '2px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '700' },
  tenantBadge: { backgroundColor: '#e0f2fe', color: '#0369a1', padding: '2px 8px', borderRadius: '12px', fontSize: '11px' },
  userName: { color: '#94a3b8', fontSize: '14px' },
  navButton: { backgroundColor: 'transparent', border: '1px solid #94a3b8', color: '#94a3b8', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '14px' },
  logoutButton: { backgroundColor: 'transparent', border: '1px solid white', color: 'white', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '14px' },
  tabs: { backgroundColor: 'white', borderBottom: '1px solid #e2e8f0', padding: '0 24px', display: 'flex' },
  tab: { padding: '14px 20px', border: 'none', backgroundColor: 'transparent', cursor: 'pointer', fontSize: '14px', color: '#64748b', borderBottom: '2px solid transparent' },
  tabActive: { color: '#1a1a2e', borderBottom: '2px solid #1a1a2e', fontWeight: '600' },
  message: { margin: '16px 24px', padding: '12px 16px', backgroundColor: '#dcfce7', borderRadius: '6px', color: '#166534', fontSize: '14px', cursor: 'pointer' },
  content: { padding: '24px' },
  card: { backgroundColor: 'white', borderRadius: '8px', padding: '24px', marginBottom: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' },
  cardTitle: { margin: '0 0 16px 0', color: '#1a1a2e', fontSize: '16px' },
  tableHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' },
  searchInput: { padding: '8px 12px', borderRadius: '4px', border: '1px solid #d1d5db', fontSize: '14px', width: '280px' },
  form: { display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'flex-end' },
  input: { padding: '8px 12px', borderRadius: '4px', border: '1px solid #d1d5db', fontSize: '14px', minWidth: '200px' },
  primaryButton: { padding: '8px 16px', backgroundColor: '#1a1a2e', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px' },
  dangerButton: { padding: '4px 10px', backgroundColor: '#ef4444', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' },
  table: { width: '100%', borderCollapse: 'collapse' },
  th: { textAlign: 'left', padding: '10px', borderBottom: '2px solid #e2e8f0', fontSize: '13px', color: '#64748b' },
  td: { padding: '10px', borderBottom: '1px solid #f1f5f9', fontSize: '14px', verticalAlign: 'top' },
  groupCard: { border: '1px solid #e2e8f0', borderRadius: '6px', marginBottom: '12px', overflow: 'hidden' },
  groupHeader: { padding: '12px 16px', backgroundColor: '#f8fafc', display: 'flex', alignItems: 'center', gap: '12px' },
  groupDesc: { color: '#94a3b8', fontSize: '13px', flex: 1 },
  groupBody: { padding: '16px' },
  badge: { backgroundColor: '#e2e8f0', borderRadius: '12px', padding: '2px 8px', fontSize: '12px' },
  label: { margin: '0 0 6px 0', fontSize: '12px', color: '#64748b' },
  tag: { backgroundColor: '#e0f2fe', color: '#0369a1', padding: '3px 8px', borderRadius: '4px', fontSize: '12px', display: 'inline-flex', alignItems: 'center', gap: '4px' },
  tagRemove: { background: 'none', border: 'none', cursor: 'pointer', color: '#0369a1', fontSize: '10px', padding: '0' },
  selectSmall: { padding: '4px 8px', borderRadius: '4px', border: '1px solid #d1d5db', fontSize: '13px', cursor: 'pointer' },
  pagination: { display: 'flex', justifyContent: 'center', gap: '4px', marginTop: '16px' },
  pageButton: { padding: '6px 10px', border: '1px solid #d1d5db', backgroundColor: 'white', borderRadius: '4px', cursor: 'pointer', fontSize: '13px' },
  pageButtonActive: { backgroundColor: '#1a1a2e', color: 'white', borderColor: '#1a1a2e' },
  feedbackItem: { padding: '12px', borderRadius: '6px', border: '1px solid #e2e8f0', marginBottom: '8px', cursor: 'pointer', transition: 'background-color 0.15s' },
  feedbackItemActive: { backgroundColor: '#eff6ff', borderColor: '#3b82f6' },
  feedbackDetail: { display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px', padding: '12px', backgroundColor: '#f8fafc', borderRadius: '6px' },
  detailRow: { display: 'flex', gap: '8px', fontSize: '13px' },
  detailLabel: { color: '#64748b', minWidth: '80px', fontWeight: '500' },
  detailValue: { color: '#1e293b' },
  detailSection: { marginBottom: '12px' },
  detailSectionTitle: { margin: '0 0 6px 0', fontSize: '12px', fontWeight: '600', color: '#64748b' },
  detailBox: { backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '6px', padding: '10px', fontSize: '13px', color: '#1e293b', whiteSpace: 'pre-wrap', lineHeight: '1.5' },
};

export default AdminPage;